module.exports = __webpack_public_path__ + "static/img/background.e48b44a0.png";